import { initializeApp } from 'firebase/app'
import { getAuth } from 'firebase/auth'

export default defineNuxtPlugin((nuxtApp) => {
  const firebaseConfig = {
    apiKey: 'AIzaSyCiNM_wB2cLbgmWfL5LM8pJvGO1ysaL-GE',
    authDomain: 'snack-prompt-6d067.firebaseapp.com',
    projectId: 'snack-prompt-6d067',
    appId: '1:625767230471:web:c770ac6c099acaa47a8ea2',
  }

  const app = initializeApp(firebaseConfig)
  const auth = getAuth(app)

  auth.onAuthStateChanged((user) => {
    if (!user) {
      sessionStorage.removeItem('wasLoggedIn')
      return
    }

    const { firebaseUser } = useFirebaseAuth()
    firebaseUser.value = user

    sessionStorage.setItem('wasLoggedIn', '1')

    createOrSigninUser(user)
  })

  nuxtApp.vueApp.provide('auth', auth)
  nuxtApp.provide('auth', auth)
})
